var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingAmount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#E65F2B",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 36C36 37.1045 36.8955 38 38 38C39.1045 38 40 37.1045 40 36C40 34.8955 39.1045 34 38 34C36.8955 34 36 34.8955 36 36Z",
    stroke: "#F24324",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 32V24C22.8063 24.8284 28.7683 25.9023 36.0051 26.4037C39.9003 26.6737 41.8479 26.8086 42.9239 27.9692C44 29.1297 44 30.9996 44 34.7395V37.4244C44 41.2755 44 43.2011 42.6884 44.3997C41.3767 45.5983 39.5892 45.4236 36.0141 45.0744C35.1429 44.9892 34.2461 44.888 33.3333 44.7683",
    stroke: "#F24324",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5011 26.6667C40.0047 24.7691 40.4604 21.3177 39.1027 19.604C38.2421 18.5178 36.9631 18.6221 35.7091 18.7324C29.1172 19.3122 24.4606 20.4898 21.8573 21.2899C20.738 21.6339 20 22.727 20 23.9473",
    stroke: "#F24324",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6667 40.0001H25.3333M25.3333 40.0001H20M25.3333 40.0001V45.3334M25.3333 40.0001V34.6667",
    stroke: "#F24324",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingAmount);
export default __webpack_public_path__ + "static/media/pending-amount.46cbb7e90e4c3b767bd4fdb7ffdd01e9.svg";
export { ForwardRef as ReactComponent };